'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fat';
var iconName = 'star-half-stroke';
var width = 576;
var height = 512;
var aliases = ["star-half-alt"];
var unicode = 'f5c0';
var svgPathData = 'M266.7-18.9c4.1-8 12.4-13.1 21.4-13.1s17.3 5.1 21.4 13.1L383 125.3 542.9 150.7c8.9 1.4 16.3 7.7 19.1 16.3s.5 18-5.8 24.4L441.7 305.9 467 465.8c1.4 8.9-2.3 17.9-9.6 23.2s-17 6.1-25 2L288.1 417.6 143.8 491c-8 4.1-17.7 3.3-25-2s-11-14.2-9.6-23.2L134.4 305.9 20 191.4c-6.4-6.4-8.6-15.8-5.8-24.4s10.1-14.9 19.1-16.3l159.9-25.4 73.6-144.2zm113.8 160c-5-.8-9.4-4-11.7-8.5l-72.7-142.5 0 413.6 143.5 73c2.7 1.4 5.9 1.1 8.3-.7s3.7-4.7 3.2-7.7L425.9 308.4c-.8-5.1 .9-10.2 4.5-13.8L544.8 180.1c2.1-2.1 2.9-5.3 1.9-8.1s-3.4-5-6.4-5.4L380.5 141.1zM280.1 403.7l0-413.6-72.7 142.5c-2.3 4.6-6.7 7.7-11.7 8.5L35.7 166.5c-3 .5-5.4 2.6-6.4 5.4s-.2 6 1.9 8.1L145.7 294.6c3.6 3.6 5.3 8.7 4.5 13.8L125 468.3c-.5 3 .8 6 3.2 7.7s5.6 2 8.3 .7l143.6-73z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faStarHalfStroke = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;